import { useEffect, useState } from "react";

interface Toast {
  id: number;
  message: string;
}

let nextId = 1;
let current: Toast[] = [];
const listeners = new Set<(toasts: Toast[]) => void>();

function emit() {
  for (const l of listeners) l(current);
}

function dismiss(id: number) {
  current = current.filter((t) => t.id !== id);
  emit();
}

/** Show a transient error toast at the bottom of the viewport. */
export function toast(message: string) {
  // collapse repeats (e.g. a retried mutation failing the same way)
  if (current.some((t) => t.message === message)) return;
  const t = { id: nextId++, message };
  current = [...current, t];
  emit();
  setTimeout(() => dismiss(t.id), 6000);
}

/** Renders the active toasts. Mount once, near the app root. */
export function Toaster() {
  const [items, setItems] = useState(current);
  useEffect(() => {
    listeners.add(setItems);
    return () => {
      listeners.delete(setItems);
    };
  }, []);

  if (items.length === 0) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-4 z-[60] flex flex-col items-center gap-2 px-4">
      {items.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => dismiss(t.id)}
          title="Dismiss"
          className="pointer-events-auto max-w-md rounded-lg border border-red-500/40 bg-[var(--surface)] px-4 py-2 text-left text-sm text-red-600 shadow-lg"
        >
          {t.message}
        </button>
      ))}
    </div>
  );
}
